// extracted by mini-css-extract-plugin
export var expandIcon = "fF_vZ";
export var rotated = "fF_v0";